import './App.css';
import './Componentes.css';
import './Menu.css';
import './text.css';
import './rows.css';

import { useState } from "react";
import Head from "./components/Head";
import CompTrabajos from "./components/CompTrabajos";
import CompInicio from "./components/CompInicio";
import CompContacto from "./components/CompContacto";
import CompSaber from "./components/CompSaber";
import Footer from "./components/Footer";

export default function App() {
  const [pagina, setPagina] = useState("inicio");

  return (
    <div>
      <Head setPagina={setPagina} />
      <div className='border'>
        {(() => {
          switch (pagina) {
            case "inicio":
              return <CompInicio setPagina={setPagina} />;
            case "trabajos":
              return <CompTrabajos setPagina={setPagina} />;
            case "contacto":
              return <CompContacto setPagina={setPagina} />;
            case "saber":
              return <CompSaber setPagina={setPagina} />;
            default:
              return null; // O cualquier componente por defecto
          }
        })()}

        <Footer />
      </div>
    </div>
  );
}

